(() => {
    const selector = "[data-lbx-drag]";

    let activeIndex;

    document.addEventListener("click", (e) => {
        const link = e.target.closest(selector);

        if (!link)
            return;

        activeIndex = link.dataset.lbxIndex;
    });

    new LBX(selector, {
        customClass: "lbx-drag",
        fullScreen: true,
        beforeShow: function () {
            const container = this.$modal.querySelector('[data-lbx-container]'),
                arrows = container.querySelectorAll(".lbx_arrow"),
                track = document.createElement("div");

            arrows.forEach((arrow, i) => {
                arrow.removeAttribute("title");
                arrow.classList.add("hover-only");
                arrow.classList.add(i === 0 ? 'js-cursor-prev' : 'js-cursor-next');
            });

            track.className = "swiper-wrapper";

            container.querySelectorAll(".lbx_item").forEach(item => {
                item.classList.add("swiper-slide");
                track.appendChild(item);
            });

            container.appendChild(track);

            container.classList.add("swiper");

            let swiper = new Swiper(container, {
                loop: true,
                speed: 700,
                keyboard: {
                    enabled: true
                },
                navigation: {
                    prevEl: arrows[0],
                    nextEl: arrows[1]
                }
            });

            swiper.slideToLoop(activeIndex || this.activeIndex, 0);
        }
    });
})();